/**
 * Build-time alias target for the UMD/IIFE bundle: in script-tag pages
 * AngularJS lives on the global, it is not imported.
 */
declare const window: { angular: ng.IAngularStatic };
const angular: ng.IAngularStatic = window.angular;
export default angular;
